export const companyProfileTabData = [
    {
        "Group Company Name":"SEMEN INDONESIA GROUP",
        "Company Name":"SEMEN INDONESIA",
        "Industry":"Construction Materials",
        "Sub-Industry":"Cement",
        "Segment Name":"COB1",
        "Banking Relationship POC Name":"KTFRO ZKOIQKNG SQALGFGG, HTUUN YQZIONQ",
        "Banking Relationship POC Contact Details":"77773333333333337777, 33653333333336745860",
        "CIF Key":"6458751302, 6457123552",
        "no_of_employees": "9694",
        "registered_address": "South Quarter, Tower A, Lt 19-20, JI. R.A. Kartini Kav.8, Cilandak Barat, Jakarta Selatan 12440, DKI Jakarta, Indonesia",
        "ownership_structure": [
            {
                "Shareholder": "Republic of Indonesia C/Q Ministry of SoE",
                "Percentage": "51.20%"
            },
            {
                "Shareholder": "Public",
                "Percentage": "48.80%"
            }],
        "km_board_of_directors": [
            {
                "Name": "Donny Arsal",
                "Position": "President Director"
            },
            {
                "Name": "Yosviandri",
                "Position": "Director of Operations"
            },
            {
                "Name": "Agung Wiharto",
                "Position": "Director of Human Capital & General Affairs"
            },
            {
                "Name": "Subhan",
                "Position": "Director of Business & Marketing"
            },
            {
                "Name": "Andriano Hosny Panangian",
                "Position": "Director of Finance & Portfolio Management"
            },
            {
                "Name": "Reni Wulandari",
                "Position": "Director of Operation"
            }
        ],
        "km_board_of_commissioners": [
            {
                "Name": "Budi Waseso",
                "Position": "President Commissioner/Independent Commissioner"
            },
            {
                "Name": "Nasaruddin Umar",
                "Position": "Independent Commissioner"
            },
            {
                "Name": "Saor Siagian",
                "Position": "Independent Commissioner"
            },
            {
                "Name": "Ratna Irsana",
                "Position": "Commissioner"
            },
            {
                "Name": "Sony Subrata",
                "Position": "Commissioner"
            },
            {
                "Name": "Lydia Silvana Djaman",
                "Position": "Commissioner"
            },
            {
                "Name": "Yustinus Prastowo",
                "Position": "Commissioner"
            }
        ],
        "other_group_companies": [
            {"company_name": "PT Semen Padang (SP)"},
            {"company_name": "PT Semen Gresik (SG)"},
            {"company_name": "PT Semen Tonasa (ST)"},
            {"company_name": "Thang Long Cement Joint Stock Company (TLCC)"},
            {"company_name": "PT Sinergi Mitra Investama (SMI)"},
            {"company_name": "PT Semen Indonesia Beton (SIB)"},
            {"company_name": "PT United Tractors Semen Gresik (UTSG)"},
            {"company_name": "PT Industri Kemasan Semen Gresik (IKSG)"},
            {"company_name": "PT Kawasan Industri Gresik (KIG)"},
            {"company_name": "PT Semen Kupang Indonesia (SKI)"},
            {"company_name": "PT Semen Indonesia Industri Bangunan* (SIIB)"},
            {"company_name": "PT Semen Indonesia Aceh (SIA)"},
            {"company_name": "PT Sinergi Informatika Semen Indonesia (SISI)"},
            {"company_name": "PT Semen Indonesia Internasional (SII)"},
            {"company_name": "PT Semen Indonesia Logistik (SILOG)"},
            {"company_name": "PT Semen Baturaja Tbk (SMBR)"},
            {"company_name": "PT Solusi Bangun Indonesia Tbk (SBI)"}
        ],
        "parent_flag":1
    },
    {
        "Group Company Name":"PLN GROUP",
        "Company Name":"PERUSAHAAN LISTRIK NEGARA, PT (PERSERO)",
        "Industry":"Energy",
        "Sub-Industry":"Electricity",
        "Segment Name":"COB2",
        "Banking Relationship POC Name":"FGFT",
        "Banking Relationship POC Contact Details":"9999999999",
        "CIF Key":"6445399958",
        "no_of_employees": "54699",
        "registered_address": "Jl. Trunojoyo Blok M-I No.135, Kebayoran Baru, Jakarta Selatan 12160, Indonesia",
        "ownership_structure": [{
            "Shareholder": "Government of the Republic of Indonesia through the Ministry of State-Owned Enterprises (BUMN)",
            "Percentage": "100%"
        }],
		"km_board_of_directors": [
			{
				"Name": "Darmawan Prasodjo",
				"Position": "President Director"
			},
			{
				"Name": "SINTHYA ROESLY",
				"Position": "Director of Finance"
			},
			{
				"Name": "EVY HARYADI",
				"Position": "Director of Transmission & System Planning"
			},
			{
				"Name": "YUSUF DIDI SETIARTO",
				"Position": "Director of Legal and Human Capital Management"
			},
			{
				"Name": "EDI SRIMULYANTI",
				"Position": "Director of Retail and Commerce"
			},
			{
				"Name": "HARTANTO WIBOWO",
				"Position": "Director of Corporate Planning and Business Development"
			},
			{
				"Name": "ADI LUMAKSO",
				"Position": "Director of Generation Managementt"
			},
			{
				"Name": "ADI PRIYANTO",
				"Position": "Director of Distribution"
			},
			{
				"Name": "WILUYO KUSDWIHARTO",
				"Position": "Director of Project Management and New Renewable Energy"
			},
			{
				"Name": "SUROSO ISNANDAR",
				"Position": "Director of Risk Management "
			}
		],
		"km_board_of_commissioners": [
			{
				"Name": "AGUS DERMAWAN WINTARTO MARTOWARDOJO",
				"Position": "President Commissioner / Independent Commissioner"
			},
			{
				"Name": "SUAHASIL NAZARA",
				"Position": "Vice President Commissioner"
			},
			{
				"Name": "CHARLES SITORUS",
				"Position": "Independent Commissioner"
			},
			{
				"Name": "ARCANDRA TAHAR",
				"Position": "Independent Commissioner"
			},
			{
				"Name": "MOHAMAD IKHSAN",
				"Position": "Commissioner"
			},
			{
				"Name": "DUDY PURWAGANDHI",
				"Position": "Commissioner"
			},
			{
				"Name": "DADAN KUSDIANA",
				"Position": "Commissioner"
			},
			{
				"Name": "TEDI BHARATA",
				"Position": "Commissioner"
			},
			{
				"Name": "SUSIWIJONO MOEGIARSO",
				"Position": "Commissioner"
			}			
		],
        "other_group_companies": [
            {"company_name": "PT PLN Indonesia Power"},
            {"company_name": "PT PLN Nusantara Power"},
            {"company_name": "PT PLN Energi Primer Indonesia"},
            {"company_name": "PT Indonesia Comnets Plus"},
            {"company_name": "PT Pelayanan Listrik Nasional Batam"},
            {"company_name": "PT PLN Nusa Daya"},
            {"company_name": "PT Prima Layanan Nasional Enjiniring"},
            {"company_name": "PT Energy Management Indonesia"},
            {"company_name": "Majapahit Holding BV"},
            {"company_name": "PT Mandau Cipta Tenaga Nusantara"},
            {"company_name": "PT Haleyora Power"},
            {"company_name": "PT Geo Dipa Energi"},
            {"company_name": "PT Unelec Indonesia"}
        ],
        "parent_flag":1
    },
    {
        "Group Company Name":"GARUDAFOOD",
        "Company Name":"TUDUNG PUTRA PUTRI JAYA",
        "Industry":"Food & Beverage",
        "Sub-Industry":"Packaged Foods",
        "Segment Name":"COB1",
        "Banking Relationship POC Name":"IQKZGFG QZDQRPQ",
        "Banking Relationship POC Contact Details":"33053333333377777777",
        "CIF Key":"7339284254",
        "no_of_employees": "",
        "registered_address": "",
        "ownership_structure": [],
        "km_board_of_directors": [
            {
                "Name": "Hardianto Atmadja",
                "Position": "President Director"
            },
        ],
        "km_board_of_commissioners": [
            {
                "Name": "Sudhamek Agoeng Waspodo Soenjoto",
                "Position": "President Commissioner"
            },
        ],
        "other_group_companies": [
            {"company_name": "Tudung Putra Putri Jaya"},
            {"company_name": "Garudafood Putra Putri Jaya Tbk"},
            {"company_name": "Garuda Timur Pacific"},
            {"company_name": "PT Sinarniaga Sejahtera"}
        ],
        "parent_flag":0
    },
    {
        "Group Company Name":"GARUDAFOOD",
        "Company Name":"GARUDAFOOD PUTRA PUTRI JAYA TBK",
        "Industry":"Food & Beverage",
        "Sub-Industry":"Packaged Foods",
        "Segment Name":"COB1",
        "Banking Relationship POC Name":"KGWTKZ EIQFRKQATSQFQ QRPOT",
        "Banking Relationship POC Contact Details":"33053333333338073553",
        "CIF Key":"7266342610",
        "no_of_employees": "8842",
        "registered_address": "Wisma Garudafood Jl. Bintaro Raya No. 10A, RT.03/RW.10, Jakarta Selatan 12240Tel: (021) 7290110",
        "ownership_structure": [{
            "Shareholder": "PT Tudung Putra Putri Jaya (“TPPJ”)",
            "Percentage": "18.54%"
        },
        {
            "Shareholder": "HSBC CMB S/A Hormel Food",
            "Percentage": "30.17%"
        },
        {
            "Shareholder": "Kusumo Dewiningrum Sunjoto",
            "Percentage": "7.57%"
        },
        {
            "Shareholder": "Pangayoman Adi Soenjoto ",
            "Percentage": "7.29%"
        },
        {
            "Shareholder": "Sudhamek Agoeng Waspodo Soenjoto ",
            "Percentage": "7.16%"
        },
        {
            "Shareholder": "Dra. Rahajoe Dewiningroem Soenjoto",
            "Percentage": "5.40%"
        },
        {
            "Shareholder": "Untung Rahardjo Sunjoto",
            "Percentage": "4.12%"
        },
        {
            "Shareholder": "Drs. Eka Susanto Widadi Sunarso",
            "Percentage": "1.54%"
        },
        {
            "Shareholder": "Hartono Atmadja",
            "Percentage": "1.27%"
        },
        {
            "Shareholder": "PT Dharma Agung Wijaya",
            "Percentage": "0.90%"
        },
        {
            "Shareholder": "Hardianto Atmadja",
            "Percentage": "0.85%"
        },
        {
            "Shareholder": "Masyarakat | Public",
            "Percentage": "15.14%"
        },
        {
            "Shareholder": "Saham Tresuri | Treasury Shares",
            "Percentage": "0.04%"
        }
    ],
        "km_board_of_directors": [
            {
                "Name": "Hardianto Atmadja",
                "Position": "President Director"
            },
            {
                "Name": "Fransiskus Johny Soegiartoh",
                "Position": "Director"
            },
            {
                "Name": "Robert Chandrakelana Adjie",
                "Position": "Director"
            },
            {
                "Name": "Paulus Tedjosutikno",
                "Position": "Director"
            },
            {
                "Name": "Johannes Setiadharma",
                "Position": "Director"
            },
            {
                "Name": "Swadheen Sharma",
                "Position": "Director"
            }
        ],
        "km_board_of_commissioners": [
            {
                "Name": "Sudhamek Agoeng Waspodo Soenjoto",
                "Position": "President Commissioner"
            },
            {
                "Name": "Pangayoman Adi Soenjoto",
                "Position": "Commissioner"
            },
            {
                "Name": "Hartono Atmadja",
                "Position": "Commissioner"
            },
            {
                "Name": "Soeharto Sunjoto",
                "Position": "Commissioner"
            },
            {
                "Name": "Swen Neufeldt",
                "Position": "Commissioner"
            },
            {
                "Name": "Donald Reginald Gadsden",
                "Position": "Commissioner"
            },
            {
                "Name": "Prof. Dorodjatun Kuntjoro-Jakti, Ph.D",
                "Position": "Independent Commissioner"
            },
            {
                "Name": "Fitra Dewata Teramihardja",
                "Position": "Independent Commissioner"
            },
            {
                "Name": "Andi Chandra",
                "Position": "Independent Commissioner"
            }
        ],
        "other_group_companies": [
            {"company_name": "Tudung Putra Putri Jaya"},
            {"company_name": "Garudafood Putra Putri Jaya Tbk"},
            {"company_name": "Garuda Timur Pacific"},
            {"company_name": "PT Sinarniaga Sejahtera"}
        ],
        "parent_flag":1
    },
    {
        "Group Company Name":"GARUDAFOOD",
        "Company Name":"GARUDA TIMUR PACIFIC",
        "Industry":"Food & Beverage",
        "Sub-Industry":"Packaged Foods",
        "Segment Name":"COB1",
        "Banking Relationship POC Name":"FGFT",
        "Banking Relationship POC Contact Details":"33053333333338073553",
        "CIF Key":"7392932473",
        "no_of_employees":"",
        "registered_address":"",
        "ownership_structure":[],
        "km_board_of_directors":[],
        "km_board_of_commissioners": [
            {
                "Name": "Hartono Atmadja",
                "Position": "President Commissioner"
            },
        ],
        "other_group_companies": [
            {"company_name": "Tudung Putra Putri Jaya"},
            {"company_name": "Garudafood Putra Putri Jaya Tbk"},
            {"company_name": "Garuda Timur Pacific"},
            {"company_name": "PT Sinarniaga Sejahtera"}
        ],
        "parent_flag":0
    },
    {
        "Group Company Name":"PERTAMINA GROUP",
        "Company Name":"PERTAMINA (PERSERO)",
        "Industry":"PERTAMBANGAN DAN PENGGALIAN",
        "Sub-Industry":"PERTAMBANGAN DAN JASA PERTAMBANGAN MINYAK DAN GAS BUMI",
        "Segment Name":"COB2",
        "Banking Relationship POC Name":"FGFT",
        "Banking Relationship POC Contact Details":"9999999999",
        "CIF Key":"6441273160, 6449736805",
        "no_of_employees": "40415",
        "registered_address": "Grha Pertamina, Jl. Medan Merdeka Timur No. 11-13, Jakarta Pusat 10110, Indonesia",
        "ownership_structure": {
            "Shareholder": "Government of the Republic of Indonesia through the Ministry of SOEs",
            "Shares": 176704471,
            "Percentage": "100%"
        },
        "km_board_of_directors": [
            {
                "Name": "Nicke Widyawati",
                "Position": "President Director & CEO"
            },
            {
                "Name": "Erry Widiastono",
                "Position": "Director of Corporate Services"
            },
            {
                "Name": "Emma Sri Martini",
                "Position": "Director of Finance"
            },
            {
                "Name": "M. Erry Sugiharto",
                "Position": "Director of Human Capital"
            }
        ],
        "km_board_of_commissioners": [
            {
                "Name": "Iggi H. Achsien",
                "Position": "President Commissioner/Independent Commissioner"
            },
            {
                "Name": "Basuki Tjahaja Purnama",
                "Position": "Vice President Commissioner"
            },
            {
                "Name": "Heru Pambudi",
                "Position": "Commissioner"
            },
            {
                "Name": "Ahmad Fikri Assegaf",
                "Position": "Independent Commissioner"
            }
        ],
        "other_group_companies": [
            {"company_name": "Saka Indonesia Sesulu"},
            {"company_name": "Pertamina Hulu West Ganal"},
            {"company_name": "Rumah Sakit Pelabuhan"},
            {"company_name": "Pelita Air Service"},
            {"company_name": "PTMN BNI PMS4 / SMG / PR1"},
            {"company_name": "Pertamina Hulu Sanga Sanga"},
            {"company_name": "Rumah Sakit Bakti Timah"},
            {"company_name": "Patra Nusa Data"},
            {"company_name": "Pertamina Hulu Rokan"},
            {"company_name": "Rumah Sakit Pelabuhan Palembang"},
            {"company_name": "Pertamina Hulu Energi MNK Sumatera Utara"},
            {"company_name": "Elnusa"},
            {"company_name": "Elnusa Trans Samudera"},
            {"company_name": "Pertamina Hulu Energi Corridor"},
            {"company_name": "Pertamina Hulu Kalimantan Timur"},
            {"company_name": "Pertamina Hulu Energi West Madura Offshore"},
            {"company_name": "PTMN BNI PMS1 / MDNPR1"},
            {"company_name": "Rumah Sakit Pelni"},
            {"company_name": "Pertamina Hulu Energi NSO"},
            {"company_name": "Patra Logistik"},
            {"company_name": "Permata Karya Jasa"}
        ],
        "parent_flag":1
    },
    {
        "Group Company Name":"GARUDAFOOD",
        "Company Name":"PT SINARNIAGA SEJAHTERA",
        "Industry":"FMCG",
        "Sub-Industry":"Consumer Goods",
        "Segment Name":"COB1",
        "Banking Relationship POC Name":"FGFT",
        "Banking Relationship POC Contact Details":"33053333333338073553",
        "CIF Key":"7339932645",
        "no_of_employees": "",
        "registered_address": "Jl. Wahab Affan No. 135, Medansatria, Kota Bekasi, Jawa Barat",
        "ownership_structure": [{
            "Shareholder": "GARUDAFOOD PUTRA PUTRI JAYA TBK",
            "Percentage": "55.70%"
        }],
        "km_board_of_directors": [
            {
                "Name": "Ruli Setiawan S.L. Tobing",
                "Position": "President Director"
            },
            {
                "Name": "Aries Soelistyo",
                "Position": "Director"
            },
            {
                "Name": "Nanang Febrianto",
                "Position": "Director"
            },
            {
                "Name": "Sunil Maheshwar Behre",
                "Position": "Director"
            }
        ],
        "km_board_of_commissioners": [
            {
                "Name": "Hardianto Atmadja",
                "Position": "President Commissioner"
            },
            {
                "Name": "Fransiskus Johny Soegiarto",
                "Position": "Commissioner"
            },
            {
                "Name": "Johannes Setiadhrma",
                "Position": "Commissioner"
            },
            {
                "Name": "Neeraj Kumar Goyal",
                "Position": "Commissioner"
            },
            {
                "Name": "Gary Thomas Fischbein",
                "Position": "Commissioner"
            }
        ],
        "other_group_companies": [
            {"company_name": "Tudung Putra Putri Jaya"},
            {"company_name": "Garudafood Putra Putri Jaya Tbk"},
            {"company_name": "Garuda Timur Pacific"},
            {"company_name": "PT Sinarniaga Sejahtera"}
        ],
        "parent_flag":0
    },
    {
        "Group Company Name":"ASTRA - UNITED TRACTORS",
        "Company Name":"UNITED TRACTORS",
        "Industry":"INDUSTRI PENGOLAHAN",
        "Sub-Industry":"INDUSTRI MESIN DAN PERLENGKAPANNYA",
        "Segment Name":"COB3",
        "Banking Relationship POC Name":"OVQF IQROQFZGKG",
        "Banking Relationship POC Contact Details":"33053333333331233299",
        "CIF Key":"6434415954",
		"no_of_employees": "37017",
		"registered_address": "Jl. Raya Bekasi Km. 22, Cakung Jakarta – 13910 Indonesia",
		"ownership_structure": [{
			"Shareholder": "PT Astra International Tbk",
			"Percentage": "59.5%"
		},
		{
			"Shareholder": "Public",
			"Percentage": "37.86%"
		},
		{
			"Shareholder": "Treasury Shares",
			"Percentage": "2.64%"
		}],
		"km_board_of_directors": [
			{
				"Name": "Frans Kesuma",
				"Position": "President Director"
			},
			{
				"Name": "Loudy Irwanto Ellias",
				"Position": "Director"
			},
			{
				"Name": "Iwan Hadiantoro",
				"Position": "Director"
			},
			{
				"Name": "Idot Supriadi",
				"Position": "Director"
			},
			{
				"Name": "Edhie Sarwono",
				"Position": "Director"
			},
			{
				"Name": "Widjaja Kartika",
				"Position": "Director"
			}
		],
		"km_board_of_commissioners": [
			{
				"Name": "Djony Bunarto Tjondro",
				"Position": "President Commissioner"
			},
			{
				"Name": "Gidion Hasan",
				"Position": "Vice President Commissioner"
			},
			{
				"Name": "Djoko Pranoto Santoso",
				"Position": "Commissioner"
			},
			{
				"Name": "Benjamin Herrenden Birks",
				"Position": "Commissioner"
			},
			{
				"Name": "Paulus Bambang Widjanarko",
				"Position": "Independent Commissioner"
			},
			{
				"Name": "Nanan Soekarna",
				"Position": "Independent Commissioner"
			}
		],
        "other_group_companies": [
            {"company_name": "PT Pamapersada Nusantara (PAMA)"},
            {"company_name": "PT Danusa Tambang Nusantara (DTN)"},
            {"company_name": "PT Unitra Persada Energia (UPE)"},
            {"company_name": "PT United Tractors Pandu Engineering (UTPE)"},
            {"company_name": "PT Karya Supra Perkasa (KSP)"},
            {"company_name": "PT Energia Prima Nusantara (EPN)"},
            {"company_name": "PT Bina Pertiwi (BP)"},
            {"company_name": "PT Universal Tekno Reksajaya (UTR)"},
            {"company_name": "UT Heavy Industry (S) Pte. Ltd. (UTHI)"},
            {"company_name": "PT Andalan Multi Kencana (AMK)"},
            {"company_name": "PT Tambang Supra Perkasa (TSP)"},
            {"company_name": "Unitra Power Pte Ltd (UP)"}
        ],
        "parent_flag":1
    },
    {
        "Group Company Name":"PUPUK INDONESIA",
        "Company Name":"PUPUK INDONESIA PERSERO",
        "Industry":"Agribusiness",
        "Sub-Industry":"Fertilizer ",
        "Segment Name":"COB4",
        "Banking Relationship POC Name":"FGFT",
        "Banking Relationship POC Contact Details":"9999999999",
        "CIF Key":"6563318744",
		"no_of_employees": "7441",
		"registered_address": "Jl. Taman Anggrek-Kemanggisan Jaya,Jakarta 11480-Indonesia",
		"ownership_structure": [{
			"Shareholder": "Goverment of the Republic of Indonesia",
			"Percentage": "100.00%"
		}],
		"km_board_of_directors": [
			{
				"Name": "RAHMAD PRIBADI",
				"Position": "President Director"
			},
			{
				"Name": "GUSRIZAL",
				"Position": "Vice President Director"
			},
			{
				"Name": "WONO BUDI TJAHYONO",
				"Position": "Finance Director"
			},
			{
				"Name": "Panji W. Ruky",
				"Position": "Director of Business Transformation"
			},
			{
				"Name": "TINA T. KEMALA INTAN",
				"Position": "Human Capital Director"
			},
			{
				"Name": "Jamsaton Nababan",
				"Position": "Director of Portfolio & Business Development"
			},
			{
				"Name": "Tri Wahyudi Saleh",
				"Position": "Director of Marketing"
			},
			{
				"Name": "Bob Indiarto",
				"Position": "Director of Production"
			},
			{
				"Name": "NINIS KESUMA ADRIANI",
				"Position": "Risk Management Director"
			}
		],
		"km_board_of_commissioners": [
			{
				"Name": "DARMIN NASUTION",
				"Position": "President Commissioner/Independent Commissioner"
			},
			{
				"Name": "MUSTOHA ISKANDAR",
				"Position": "Independent Commissioner"
			},
			{
				"Name": "ANHAR ADEL",
				"Position": "Independent Commissioner"
			},
			{
				"Name": "FARHAT BRACHMA",
				"Position": "Commissioner"
			},
			{
				"Name": "FEBRIO NATHAN KACARIBU",
				"Position": "Commissioner"
			},
			{
				"Name": "SUWANDI",
				"Position": "Commissioner"
			},
			{
				"Name": "ARI DWIPAYANA",
				"Position": "Commissioner"
			},
			{
				"Name": "ANWAR SANUSI",
				"Position": "Commissioner"
			},
			{
				"Name": "RISWINANDI",
				"Position": "Independent Commissioner"
			}
		],
        "other_group_companies": [
            {"company_name": "PT Petrokimia Gresik"},
            {"company_name": "PT Pupuk Kujang"},
            {"company_name": "PT Pupuk Kalimantan Timur"},
            {"company_name": "PT Pupuk Iskandar Muda"},
            {"company_name": "PT Pupuk Sriwidjaja Palembang"},
            {"company_name": "PT Rekayasa Industri"},
            {"company_name": "PT Pupuk Indonesia Niaga"},
            {"company_name": "PT Pupuk Indonesia Logistik"},
            {"company_name": "PT Pupuk Indonesia Utilitas"},
            {"company_name": "PT Pupuk Indonesia Pangan"}
        ],
        "parent_flag":1
    }
]